// ── Certificate surfaces (Wave 8 — live readiness client) ──────────────────
// Wires CertificatesPage as the body for /certificates via `customBody`. The
// page reads GET /certificates and exposes the staff-only POST issue action via
// the readiness client. A null artifactRef remains an honest pending document;
// denied and unavailable responses remain runtime postures.

import type { ProductScreenContract } from "./product-route-contracts";
import { CertificatesPage } from "./certificates/certificates-page";

const CERTIFICATES_OWNER = "VIL-20260608-0026";

export function certificatesScreen(): ProductScreenContract {
  return {
    title: () => "Certificates",
    primaryJob:
      "Issue certificates and track their status through the live Coaching certificate contract.",
    secondaryJob:
      "Certificate rows come from GET /certificates; pending artifact documents stay visibly unavailable. Administration is staff-only.",
    workTitle: "Certificate status",
    rows: [{ id: "certificates", state: "live-read", behavior: "GET /certificates; POST /certificates for staff" }],
    columns: [
      { key: "state", header: "State" },
      { key: "behavior", header: "Behavior" }
    ],
    states: ["loading", "empty", "permission-denied", "unavailable", "error"],
    apiFamilies: ["certificate-service (GET/POST /certificates)"],
    roleDeltas:
      "Staff read certificate status and may issue where authorized; coach/company_admin/cohort_lead/PARTICIPANT are denied the admin module. Null artifactRef remains pending, never a fabricated download.",
    extensionSlots: ["certificate download when artifactRef is present", "capstone→certificate trigger"],
    mobilePosture: "Certificate status, pending-document state, and staff issue controls stack with no horizontal overflow.",
    evidenceRequirement:
      "Playwright must prove the live read, staff authorization, pending artifact honesty, runtime unavailable/error states, and participant/non-staff denial.",
    vjalComponents: ["Alert","Badge","Button","CollectionToolbar","Input","Module","ModuleBody","ModuleHead","PageFrame","ProTable"],
    localCompositions: ["certificates focused product surface"],
    packageGapRefs: [],
    decisionHierarchy: {
      firstViewport: "The not-configured certificates notice.",
      primaryAction: "Read the honest status; nothing can be issued until the backend lands.",
      secondaryPanel: "An info note on how certificates will work once connected (capstone-triggered).",
      deferredSurface: "Issuance, status, and download land with the certificate backend.",
      gatedControls: "Whole module not-configured; issue disabled; non-staff + participant denied."
    },
    requiredViewports: ["desktop", "mobile"],
    surfaceMode: "focused",
    closureState: "focused",
    closureOwner: CERTIFICATES_OWNER,
    customBody: CertificatesPage
  } as ProductScreenContract;
}
